import {PayloadAction} from "@reduxjs/toolkit"
import {Dispatch} from "react"
import {ScheduledShipmentRepositoryInstance} from "../../repository/Order/ScheduledShipmentRepository";
import {ActionTypes} from "../../redux/Order/ScheduledShipmentReducer";

/**
 * UserService.
 *
 */
export class ScheduledShipmentService {
    private dispatch: Dispatch<PayloadAction<any>>
    private repository = ScheduledShipmentRepositoryInstance

    constructor(dispatch: Dispatch<PayloadAction<any>>) {
        this.dispatch = dispatch
    }

    public async all(data: any) {
        return await this.repository.all(data).then(res => {
            this.dispatch({
                type: ActionTypes.SCHEDULED_SHIPMENT_ALL,
                payload: res.Some
            })
            return res.Some
        })
    }

    public async remove(params: {}) {
        return await this.repository.remove(params).then(res => {
            return res.Some
        })
    }

    public async force(params: {}) {
        return await this.repository.force(params).then(res => {
            return res.Some
        })
    }

    public async create(data: any) {
        return await this.repository.createOrEdit(data).then(res => {
            return res
        })
    }

    public async edit(data: any) {
        return await this.repository.createOrEdit(data).then(res => {
            return res
        })
    }

    public clearListShipment() {
        this.dispatch({type: ActionTypes.CLEAR_ALL, payload: []});
    }
}



